import axios from "axios";
import { currentApiUrlPrefix } from './EnvironmentVariable';
//console.log(process.env.REACT_APP_BACKEND_URL);
const Axios = axios.create({  
  // baseURL: window.location.origin + '/api/'
  // baseURL: `http://10.1.14.4:9042/api/`
  baseURL: `${currentApiUrlPrefix}/api/`
});

export default Axios;